<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'PROPERTY_TYPE_TEMPLATES', url: '/admin/property-type-templates' },
    { label: 'UPDATE_TEMPLATE' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_TEMPLATE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PROPERTY_TYPE">{{
        'PROPERTY_TYPE' | translate
      }}</label>
      <div class="control is-relative">
        <input
          class="input is-small"
          name="propertyType"
          readonly
          type="text"
          [value]="getField(['propertyType'])"
          [ngClass]="{ 'is-danger': hasError('propertyType') }"
          style="cursor: default"
        />
        <button
          class="button p-1"
          type="button"
          (click)="isPropertyTypesOpen = true"
          style="
            position: absolute;
            top: 0px;
            right: 8px;
            height: auto;
            border: 0;
            background: transparent;
            outline: none !important;
            box-shadow: none !important;
          "
        >
          <span class="icon is-small">
            <i class="fa-regular fa-pen-to-square"></i>
          </span>
        </button>
      </div>
      <p class="help is-danger" *ngIf="hasError('propertyType')">
        {{ getError('propertyType') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="TEMPLATE">{{
        'TEMPLATE' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="templates"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'templateId')"
          [ngClass]="{ 'is-danger': hasError('templateId') }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['template', 'id'])"
          [typeahead]="onTemplatesAutocomplete$"
          class="is-small"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('templateId')">
        {{ getError('templateId') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/property-type-templates']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>

<property-type-modal
  (onClose)="isPropertyTypesOpen = false"
  (onSave)="handleFieldChange($event, 'propertyType')"
  [isOpen]="isPropertyTypesOpen"
></property-type-modal>
